import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header_Btn.css";

const Header_Btn = ({ text, link, onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <button className={`claim_btn ${className}`} onClick={handleClick}>
      {text}
    </button>
  );
};

export default Header_Btn;
